"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShipToAddressPage = exports.CheckOutType = exports.defaultDeliveryRequirements = exports.defaultReceivingDays = void 0;
exports.defaultReceivingDays = [{
  id: 1,
  code: "Mon",
  description: "Monday",
  startTime: "08:00",
  endTime: "17:00"
}, {
  id: 2,
  code: "Tue",
  description: "Tuesday",
  startTime: "08:00",
  endTime: "17:00"
}, {
  id: 3,
  code: "Wed",
  description: "Wednesday",
  startTime: "08:00",
  endTime: "17:00"
}, {
  id: 4,
  code: "Thu",
  description: "Thursday",
  startTime: "08:00",
  endTime: "17:00"
}, {
  id: 5,
  code: "Fri",
  description: "Friday",
  startTime: "08:00",
  endTime: "17:00"
}];
exports.defaultDeliveryRequirements = {
  unloadWeight: 100,
  partialShipmentDescription: "Okay to ship as available",
  truckUnload: "Side",
  unloadBy: "Forklift",
  receivingDays: exports.defaultReceivingDays,
  calendarType: "U",
  loadingInstructions: ""
};
var CheckOutType;

(function (CheckOutType) {
  CheckOutType["CART"] = "cart";
  CheckOutType["QUOTE"] = "quote";
  CheckOutType["INVOICE"] = "invoice";
})(CheckOutType || (exports.CheckOutType = CheckOutType = {}));

var ShipToAddressPage;

(function (ShipToAddressPage) {
  ShipToAddressPage["ACCOUNT_SETTINGS"] = "account_settings";
  ShipToAddressPage["SHIPPING_BILLING"] = "shipping_billing";
})(ShipToAddressPage || (exports.ShipToAddressPage = ShipToAddressPage = {}));